module.exports = __webpack_public_path__ + "static/img/1_10_1.7af04188.jpg";